import { ApiResponse, PaginatedResponse } from "../types/common";
import {
  FloatingBadge,
  CreateFloatingBadgeRequest,
  UpdateFloatingBadgeRequest,
  FloatingBadgeFilter,
} from "../types/landing";
import api from "./api";

// Floating Badge CRUD Operations
export const floatingBadgeService = {
  getAllFloatingBadges: async (
    filters: FloatingBadgeFilter = {}
  ): Promise<PaginatedResponse<FloatingBadge>> => {
    try {
      const params = new URLSearchParams();

      if (filters.page) params.append("page", filters.page.toString());
      if (filters.limit) params.append("limit", filters.limit.toString());
      if (filters.status) params.append("status", filters.status);
      if (filters.position) params.append("position", filters.position);

      const response = await api.get(
        `/landing/floating-badges/admin?${params.toString()}`
      );

      const data = response as any;
      return {
        success: data.success,
        data: data.data || [],
        pagination: data.pagination || {
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
          itemsPerPage: filters.limit || 10,
        },
      };
    } catch (error) {
      console.error("Error fetching floating badges:", error);
      throw error;
    }
  },

  getFloatingBadge: async (id: string): Promise<ApiResponse<FloatingBadge>> => {
    try {
      const response = await api.get(`/landing/floating-badges/${id}`);
      return response as any;
    } catch (error) {
      console.error("Error fetching floating badge:", error);
      throw error;
    }
  },

  createFloatingBadge: async (
    badgeData: CreateFloatingBadgeRequest
  ): Promise<ApiResponse<FloatingBadge>> => {
    try {
      const response = await api.post("/landing/floating-badges", badgeData);
      return response as any;
    } catch (error) {
      console.error("Error creating floating badge:", error);
      throw error;
    }
  },

  updateFloatingBadge: async (
    id: string,
    badgeData: UpdateFloatingBadgeRequest
  ): Promise<ApiResponse<FloatingBadge>> => {
    try {
      const response = await api.put(
        `/landing/floating-badges/${id}`,
        badgeData
      );
      return response as any;
    } catch (error) {
      console.error("Error updating floating badge:", error);
      throw error;
    }
  },

  deleteFloatingBadge: async (id: string): Promise<ApiResponse<null>> => {
    try {
      const response = await api.delete(`/landing/floating-badges/${id}`);
      return response as any;
    } catch (error) {
      console.error("Error deleting floating badge:", error);
      throw error;
    }
  },

  activateFloatingBadge: async (
    id: string
  ): Promise<ApiResponse<FloatingBadge>> => {
    try {
      const response = await api.patch(
        `/landing/floating-badges/${id}/activate`
      );
      return response as any;
    } catch (error) {
      console.error("Error activating floating badge:", error);
      throw error;
    }
  },

  deactivateFloatingBadge: async (
    id: string
  ): Promise<ApiResponse<FloatingBadge>> => {
    try {
      const response = await api.patch(
        `/landing/floating-badges/${id}/deactivate`
      );
      return response as any;
    } catch (error) {
      console.error("Error deactivating floating badge:", error);
      throw error;
    }
  },

  updateFloatingBadgeOrder: async (
    id: string,
    displayOrder: number
  ): Promise<ApiResponse<FloatingBadge>> => {
    try {
      const response = await api.patch(`/landing/floating-badges/${id}/order`, {
        displayOrder,
      });
      return response as any;
    } catch (error) {
      console.error("Error updating floating badge order:", error);
      throw error;
    }
  },
};
